import styles from './SysOption.module.css'
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import React, {useEffect, useRef, useState} from "react";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import WaitLoader from "../../WaitLoader/WaitLoader";
import TableItem from "../../FormTemplate/TableItem/TableItem";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import SMSSender from "./SMSSender";
export interface TableItemDataItemInt
{
    [key:string]:any
}

interface SysOptionItemInt
{
    id:number
    type:number
    name: string
    val: string
    desc: string
}

interface SysOptionBlockInt
{
    name: string
    desc:string
    dropped: boolean
    itemList: SysOptionItemInt[]
}


export default function SysOption()
{
    const [dataItem, setDataItem] = useState<TableItemDataItemInt>()
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const updData = useRef({
        id:-1,
        fieldList:new Array<string>,
        valList:new Array<any>
    })
    const [ldrUpdData,rsUpdData,exUpdData] = useApiQuery("/ref/sysoption/update","post",updData);


    const [optData, setOptData] = useState<SysOptionBlockInt[]>([])
    const optionData = useRef()
    const [ldrOption,rsOption,exOption] = useApiQuery("/ref/sysoption","get",optionData);

    useEffect(()=>{
        loadData()
    },[optionData])

    const loadData = ()=>{
        exOption().then((e)=>{
            if(e?.success)
            {
                const payload = e?.payload
                if(! Array.isArray(payload)) return
                const p:SysOptionBlockInt[] = payload?.map((item)=>{
                    return{
                        dropped: false,
                        name: item?.name,
                        desc: item?.desc,
                        itemList: item?.partList


                    }
                })


                setOptData(p)
            }
        })

    }

    const handleUpdate = () =>{
        if(dataItem?.id === undefined) return
        updData.current.id = dataItem?.id
        updData.current.fieldList= []
        updData.current.valList=[]

        updData.current.fieldList.push("val")
        updData.current.valList.push((typeof  dataItem?.val === "string" ? dataItem?.val?.trim() : dataItem?.val.toString()))

        console.log(updData.current)

        exUpdData().then((e)=>{
            console.log(e)
            if(e?.success !== undefined && e.success)
            {
                if(errorLineRef.current !== null)errorLineRef.current?.show("Задача выполнена",false,2000)
                loadData()
                return
            }
            if(errorLineRef.current !== null)errorLineRef.current?.show(e?.errorAsString ? e.errorAsString : "Ошибка сервера",true,2000)

        })


    }

    const buildSysOptionItem = (data:any[]) =>{
        if(! Array.isArray(data)) return null

        const a = data?.map((item:any,idx)=>{
            return(
                <li key={idx}>
                    <div className={styles.itmCont}
                        onClick={()=>setDataItem(item)}
                    >
                        <div className={styles.itmTitle}>{item?.name}</div>
                        <div className={styles.itmVal}>{item?.val}</div>
                    </div>
                </li>
            )
        })
        return (
            <div className={styles.lineCont}>
                <ul>{a}</ul>

            </div>
        )
    }

    const setDropped = (id:number)=>{
        setOptData( optData?.map((item,idx)=>{
            if(idx === id) item.dropped = !item.dropped
            return item
        }))
    }

    const buildSysOptionList = () =>{
        const list = optData?.map((item,idx)=>{
            return(
                <div key={idx} className={styles.listCont}>
                    <li >
                        <div className={styles.optHead}
                            onClick={()=>setDropped(idx)}
                        >{item?.desc}</div>
                        {item?.dropped && buildSysOptionItem(item?.itemList)}
                    </li>
                </div>
            )

        })
        return(
            <ul> {list}</ul>
        )

    }


    return(
        <div className={[styles.mainCont].join(' ')}>
            <WaitLoader loading={ldrOption} api={rsOption} onlyLoading={true}>
                <div className={styles.optCont}>
                    {buildSysOptionList()}
                </div>
            </WaitLoader>

            <MainFormTemplate title={"Переменные среды"} maxWidth={"1200px"}>
                <ActiveRecordItem active={dataItem?.id ? true : false}></ActiveRecordItem>

                <div className={"row"}>
                    <div className={"col-sm-6"}>
                        <InputItem
                            val={dataItem?.name}
                            mode={""}
                            title={"Параметр"}
                            />
                    </div>
                    <div className={"col-sm-6"}>
                        <InputItem
                            val={dataItem?.val}
                            mode={"ei"}
                            info={"Значение"}
                            title={"Значение"}
                            regExp={/^[\w\W]+/ui}
                            lineCount={4}
                            inputType={2}
                            onBlur={(e)=>setDataItem({...dataItem,val:e})}

                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <InputItem
                            val={dataItem?.desc}
                            mode={""}
                            title={"Параметр"}
                            inputType={2}
                            lineCount={3}
                        />
                    </div>
                </div>
                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
                <div className={"row"}>
                    <div className={"col-sm-2 d-flex align-self-center"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={dataItem?.id ? false: true}
                                    onClick={()=>handleUpdate()}
                            >Обновить</button>
                            <WaitLoader loading={ldrUpdData} api={rsUpdData} onlyLoading={true} >
                            </WaitLoader>

                        </div>
                    </div>
                </div>


            </MainFormTemplate>
            {false &&
                <SMSSender/>
            }



        </div>
    )
}